module.exports = __webpack_public_path__ + "static/fonts/iconfont.70068ce.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_custom/iconfont.ttf?t=1566030762759
// module id = 461
// module chunks = 99